import * as api from "../Services/api.js";
import AARAssessment from "../../objs/AARAssessment.ts";
export const state = {
  assessments: [],
};
export const mutations = {
  SET_ASSESSMENTS(state, payload) {
    state.assessments = payload.map((item) => new AARAssessment(item));
  },
  ADD_ASSESSMENTS(state, payload) {
    state.assessments.push(...payload.map((item) => new AARAssessment(item)));
  },
  UPDATE_ASSESSMENT(state, payload) {
    state.assessments = state.assessments.map((item) => {
      return item.aarAssessmentId === payload.aarAssessmentId
        ? new AARAssessment(payload)
        : item;
    });
  },
  DELETE_ASSESSMENT(state, aarAssessmentId) {
    state.assessments = state.assessments.filter(
      (item) => item.aarAssessmentId !== aarAssessmentId
    );
  },
};
export const getters = {};
export const actions = {
  async getAARAssessments({ commit }, data) {
    return await api
      .getQuery("/MTA/getAARAssessments", { startDate: data })
      .then((response) => {
        if (response.success) {
          commit("SET_ASSESSMENTS", response.data);
        }
        return response.success;
      })
      .catch((error) => {
        return false;
      });
  },
  async uploadAssessments({ commit, dispatch }, data) {
    return await api
      .uploadFiles(
        "/MTA/uploadAssessments",
        { dateOfService: data.dateOfService, aarLocation: data.aarLocation },
        data
      )
      .then((response) => {
        if (response.success) {
          commit("ADD_ASSESSMENTS", response.data);
        }
        return response.success;
      })
      .catch((error) => {
        return false;
      });
  },
  async updateAARAssessment({ commit }, data) {
    return await api
      .postQuery("/MTA/updateAARAssessment", data)
      .then((response) => {
        if (response.success) {
          commit("UPDATE_ASSESSMENT", response.data);
        }
        return response.success;
      })
      .catch((error) => {
        return false;
      });
  },
  async deleteAARAssessment({ commit }, data) {
    return await api
      .postQuery("/MTA/deleteAARAssessment", {
        aarAssessmentId: data,
      })
      .then((response) => {
        if (response.success) {
          commit("DELETE_ASSESSMENT", data);
        }
        return response.success;
      })
      .catch((error) => {
        return false;
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
